import CustomInput from "@/components/inputElements/ui/customInput";
import React, { useState } from "react";
import QwidBtn from "../QwidBtn";
import Image from "next/image";
import { X } from "lucide-react";
import api from "@/lib/axios"
// import useUserProps from "@/hooks/user/useUserProps";
import useToolkit from "@/hooks/misc/useToolkit";
import { loginUser, logoutUser } from "@/redux/slices/userSlice";
import { setContactDataCompletedStatus, setCountry, setEmailVerificationStatus, setKycLevel, setMobileVerificationStatus, setPersonalDataCompletedStatus, setPinSetupStatus, setSecurityQuestionSetupStatus, setSetUsertype } from "@/redux/slices/checkerSlice";
import { APP_ROUTES } from "@/lib/routing/appRoutes";
import { useRouter } from "next/navigation";
import Cookies from 'js-cookie';

interface UserData {
  name: string
  email: string
}

export default function SessionTimeoutModal({ open, onClose }: {
  open: boolean
  onClose: () => void
}) {
  const { toastError, dispatch } = useToolkit()
  const [isLoading, setIsLoading] = useState(false)
  const [password, setPassword] = useState("")
  const router = useRouter()

  const lastUser = Cookies.get("lastUser")
  const userEmail = lastUser ? JSON.parse(lastUser)?.email : ""

  const handleSignIn = async () => {
    if (!userEmail || !password) return

    setIsLoading(true)
    try {
      const form = {
        email: userEmail,
        password: password,
        platform: "web",
      }
      const { data } = await api.post("login", form)
      const response = data?.content?.data
      const firstName = response?.enduser?.[0]?.firstName || ""

      const userData: UserData = {
        name: firstName,
        email: userEmail,
      }

      localStorage.setItem("lastUser", JSON.stringify(userData))

      dispatch(loginUser(response))
      dispatch(setEmailVerificationStatus(response?.checkSteps?.email_verify_completed))
      dispatch(setMobileVerificationStatus(response?.checkSteps?.mobile_verify_completed))
      dispatch(setPersonalDataCompletedStatus(response?.checkSteps?.personal_data_completed))
      dispatch(setContactDataCompletedStatus(response?.checkSteps?.contact_data_completed))
      dispatch(setPinSetupStatus(response?.checkSteps?.pin_setup))
      dispatch(setSecurityQuestionSetupStatus(response?.checkSteps?.security_question_setup))
      dispatch(setSetUsertype(response?.enduser?.[0]?.userType))
      dispatch(setKycLevel(response?.kyc?.kycTier?.level))
      dispatch(setCountry(response?.enduser[0]?.countryCode))
      setTimeout(() => {
        if (typeof window !== "undefined") {
          window?.location?.reload()
        }
      }, 100);
      onClose()
      setTimeout(() => {
        if (typeof window !== 'undefined') {
          window.location.reload()
        }
      }, 100);
    } catch (error: any) {
      const errorResponse = error?.response.data.message
      if (typeof errorResponse === 'string') {
        toastError(errorResponse)
      }
    } finally {
      setIsLoading(false)
    }
  }


  if (!open) return null;

  return (
    <>

    
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSignIn();
        }}
      >
        <div
          className="fixed inset-0 z-999 flex items-center justify-center bg-black/40 backdrop-blur-sm animate-fadeIn"
        >
          <div
            className="bg-white rounded-2xl w-[400px] shadow-xl p-3 max-w-md animate-scaleIn"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex space-x-3 justify-between mb-12">
              <div className="flex space-x-2">
                <Image
                  src="/assets/icons/locked.svg"
                  alt="locked"
                  width={40}
                  height={40}
                />
                <div>
                  <p className="text-[#0A0A0C] font-medium text-base">
                    Session Timed Out
                  </p>
                  <p className="text-[#92939E] font-normal text-sm">
                    You were logged out due to inactivity.
                    <br />
                    Please enter your password to continue.
                  </p>
                </div>
              </div>

              <X
                className="cursor-pointer"
                onClick={() => {
                  dispatch(logoutUser())
                  localStorage.removeItem("qwid-token");
                  router.replace(APP_ROUTES.GENERAL.HOMEPAGE);
                  setTimeout(() => {
                    onClose();
                  }, 500);
                }}
              />
            </div>

            <div>
              <CustomInput type="hidden" value={userEmail} />

              <CustomInput
                onChange={(e) => setPassword(e.target.value)}
                showPasswordToggle
                type="password"
                label="Password"
                placeholder="Enter your password"
              />
            </div>

            <div className="flex justify-between items-center mt-10">
              <div className="w-full" />

              <QwidBtn
                primary
                loading={isLoading}
                text="Login"
                type="submit"
              />
            </div>
          </div>
        </div>
      </form>


      <style jsx>{`
        .animate-fadeIn {
          animation: fadeIn 0.25s ease-out;
        }
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        .animate-scaleIn {
          animation: scaleIn 0.25s ease-out;
        }
        @keyframes scaleIn {
          from { transform: scale(0.95); opacity: 0; }
          to { transform: scale(1); opacity: 1; }
        }
      `}</style>

    </>
  );
}
